import { observer } from 'mobx-react'
import React, { useMemo, useState } from 'react'
import { memberMobx, memberCardMobx, storeMobx } from '@mobxStore'
import { IonSlides, IonSlide, useIonViewDidEnter } from '@ionic/react'
import MyCardItem from './cardItem'
import { cloneDeep, each, find, keyBy } from '@dt/fe-utils/dist/lodash'
import mktController from 'controllers/mktController'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps {
  type: 'mall' | 'meal';
  noPurchasedCardMap: any;
}

const OpenCardSlides: React.FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { noPurchasedCardMap, type } = props
  const { noPurchasedCards } = memberMobx
  const { cardList } = memberCardMobx
  const [coverCard, setCoverCard] = useState<number>(0)
  const cardBuyList: any[] = useMemo(() => {
    const saveList: any = []
    const list: any = []
    each(noPurchasedCards, (item: any) => {
      const info = find(cloneDeep(cardList), x => x.cardId === item.cardId && (item?.isAllStore || item?.storeIds?.includes(storeMobx?.info?.storeId)))
      if (info?.cardId) {
        if (noPurchasedCardMap && noPurchasedCardMap[info.cardId] && ((type === 'meal' && info.discountType) || (type === 'mall' && info.mallDiscountType))) {
          info.thriftOff = noPurchasedCardMap[info.cardId].thriftOff
          if (noPurchasedCardMap[info.cardId]?.activityProducts?.length) {
            const scalesMap = keyBy(info.scales, 'cardScaleId')
            const newScales = []
            each(noPurchasedCardMap[info.cardId].activityProducts, (actInfo: any) => {
              const scale = scalesMap[parseFloat(actInfo.productNo)]
              if (scale) {
                scale.activityProducts = actInfo
                newScales.push(scale)
              }
            })
            if (newScales.length) info.scales = newScales
          }
          saveList.push(info)
        } else {
          info.thriftOff = 0
          if (type === 'mall' && (info.mallDiscountType || info.mallMoney)) {
            list.push(info)
          } else if (type === 'meal' && (info.discountType || info.money)) {
            list.push(info)
          }
        }
      }
    })
    return saveList.concat(list)
  }, [cardList, noPurchasedCards, noPurchasedCardMap])
  const buyCard = () => {
    mktController.checkLogin(history).then(() => {
      history.push(`/iCard/cardOpen/open/${cardBuyList[coverCard].cardId}`)
    })
  }
  const initOpts = {
    initialSlide: 0,
    autoplay: false,
    loop: cardBuyList.length > 2,
    on: {
      slideChange () {
        const swiper = this as any
        setCoverCard(swiper.realIndex)
      }
    }
  }
  useIonViewDidEnter(() => {
    if (!memberCardMobx.cardList.length) {
      memberCardMobx.getCardList()
    }
  })
  if (noPurchasedCards?.length === 0) return <></>
  return (
    cardBuyList?.length > 0 && (
      <div className='open-card-slides'>
        <IonSlides className='card-slides' options={initOpts} onIonSlideTap={buyCard} key={cardBuyList.map((item: any) => item.thriftOff || item.cardId).join('_')}>
          {
            cardBuyList.map((item: any, index: number) => {
              return item && (
                <IonSlide key={index}>
                  <div className='card-area'>
                    <MyCardItem cardInfo={item} type={type}></MyCardItem>
                  </div>
                </IonSlide>
              )
            })
          }
        </IonSlides>
      </div>
    )
  )
}

export default observer(OpenCardSlides)
